export const GET_NEWS_STORIES_START = 'News/GET_NEWS_STORIES_START';
export const GET_NEWS_STORIES_SUCCESS = 'News/GET_NEWS_STORIES_SUCCESS';
export const GET_NEWS_STORIES_FAILURE = 'News/GET_NEWS_STORIES_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/News/store/constants.js